import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ResourcesService } from '../resources/resources.service';
import { Constants } from '../app.constants';
import { UserService } from '../user/user.service';
import { Title } from '@angular/platform-browser';
import { TranslateOrgSpecificPipe } from '../common/pipes/translate-org-specific.pipe';

@Component({
  selector: 'app-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.css']
})
export class DocumentViewComponent implements OnInit {

  constructor(private router: Router, private route: ActivatedRoute, private titleService: Title, private orgSpecificPipe: TranslateOrgSpecificPipe,
    private resourceService: ResourcesService, private userService: UserService) { }
  Fileurl: string;
  url_available = false;
  is_image_or_video = false;
  is_word_doc = false;
  is_pdf = false;
  invalid = false;
  imageTypes: string[] = ['jpg', 'jpeg', 'png'];
  videoTypes: string[] = ['mp4'];
  wordDocTypes: string[] = ['doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'];
  pdfType = Constants.pdfType;
  Doc_view_source: string;
  ngOnInit() {
    // set title
    this.titleService.setTitle(this.orgSpecificPipe.transform('Library') + ' | ' + this.orgSpecificPipe.transform('PageTitle'));
    let fileName, fileExtension;
    this.route.params.subscribe(param => {
      if (param['fileUrl']) {
        fileName = param['fileUrl'];
        fileExtension = fileName.replace(/^.*\./, '');
        if (this.imageTypes.find(ele => ele == fileExtension)) {
          this.is_pdf = false;
          this.is_word_doc = false;
          this.is_image_or_video = true;
        } else if (this.wordDocTypes.find(ele => ele == fileExtension)) {
          this.is_image_or_video = false;
          this.is_pdf = false;
          this.is_word_doc = true;
        } else if (this.videoTypes.find(ele => ele == fileExtension)) {
          this.is_pdf = false;
          this.is_word_doc = false;
          this.is_image_or_video = true;
        } else if (fileExtension == this.pdfType) {
          this.is_word_doc = false;
          this.is_image_or_video = false;
          this.is_pdf = true;

        } else {

          this.invalid = true;
        }
        if (param['source']) {
          this.Doc_view_source = param['source'];
        } else {
          this.Doc_view_source = '';

        }

        this.resourceService.getUrl(param['fileUrl'], this.Doc_view_source).subscribe(data => {
          if (data) {
            const link = data['fileUrl'];
            this.Fileurl = link;
            this.url_available = true;
          }
        });
      }
    });


  }

}
